// @flow
import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  actions as favoriteActions,
  type State as FavoriteState,
} from 'redux/modules/favorite'
import { setUIState, containerIds } from 'redux/modules/ui'
import CardSpaceWithMemo, {
  type FavoriteCardState,
} from 'components/molecules/CardSpaceWithMemo'

export type PropTypes = {
  favorite: FavoriteState,
  localUser: {
    username: string,
  },
  ui: {
    favoriteCardStates: Array<FavoriteCardState>,
    isOpenSelectFavoriteSelectModal: boolean,
    onClickOpenDeleteFavoriteListItemModal: Function,
    onClickCloseDeleteFavoriteListItemModal: Function,
    isOpenDeleteFavoriteListItemModal: boolean,
  },
  actions: {
    updateFavoriteMemo: Function,
    setUIState: Function,
  },
}

class FavoriteCardListContainer extends React.Component<PropTypes, *> {
  constructor(props: PropTypes) {
    super(props)
    props.actions.setUIState(containerIds.FAVORITE, {
      favoriteCardStates: props.favorite.favoriteListDetail.favorites.map(
        favorite => ({
          isOpen: false,
          isOpenWritableMemo: false,
          memo: favorite.memo || '',
        }),
      ),
    })
  }

  setFavoriteCardUIState = (index, newState: Object) => {
    const favoriteCardStates = this.props.ui.favoriteCardStates
    favoriteCardStates[index] = {
      ...favoriteCardStates[index],
      ...newState,
    }
    this.props.actions.setUIState(containerIds.FAVORITE, {
      favoriteCardStates,
    })
  }

  render() {
    const { favorite, ui, localUser, actions } = this.props
    const favoriteCardStates = ui.favoriteCardStates || []
    const favoriteListDetail = favorite.favoriteListDetail

    return (favorite.favoriteListDetail.favorites || []).map(
      (favoriteData, index) => {
        if (
          favoriteData.registered_favorite_lists.includes(favoriteListDetail.id)
        ) {
          const favoriteCardState =
            favoriteCardStates.length > index
              ? ui.favoriteCardStates[index]
              : {}
          return (
            <CardSpaceWithMemo
              key={`favoriteCard_${index}`}
              favoriteData={favoriteData}
              favoriteCardState={favoriteCardState}
              onClickSaveMemo={() =>
                actions.updateFavoriteMemo({
                  userId: localUser.username,
                  favoriteListId: favoriteListDetail.id,
                  favorableId: favoriteData.id,
                  memo: favoriteCardState.memo,
                  favoriteIndex: index,
                  favoriteCardStates,
                })
              }
              onChangeMemo={e =>
                this.setFavoriteCardUIState(index, { memo: e.target.value })
              }
              toggleMemoText={() =>
                this.setFavoriteCardUIState(index, {
                  isOpen: !favoriteCardState.isOpen,
                })
              }
              toggleWritableMemo={() =>
                this.setFavoriteCardUIState(index, {
                  isOpenWritableMemo: !favoriteCardState.isOpenWritableMemo,
                })
              }
              onClickSelectList={e => {
                e.preventDefault()
                const otherFavoriteList = favorite.favoriteList.find(
                  list => list.id !== favoriteListDetail.id,
                )
                if (otherFavoriteList) {
                  actions.addFavorite({
                    userId: localUser.username,
                    roomId: favoriteData.id,
                    favoriteListId: otherFavoriteList.id,
                  })
                }
              }}
              onClickOpenSelectFavoriteListItemModal={roomId => {
                actions.setUIState(containerIds.FAVORITE, {
                  selectFavoriteListItemModal: {
                    isOpen: true,
                    roomId,
                  },
                })
              }}
              onClickOpenDeleteFavoriteListItemModal={roomId => {
                actions.setUIState(containerIds.FAVORITE, {
                  deleteFavoriteListItemModal: {
                    isOpen: true,
                    roomId,
                  },
                })
              }}
            />
          )
        }
      },
    )
  }
}

function mapStateToProps(state: Object) {
  return state
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = { setUIState, ...favoriteActions }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FavoriteCardListContainer)



// WEBPACK FOOTER //
// ./src/containers/organisms/FavoriteCardList/index.jsx